var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutOfStockRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E50B20",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 12.8002C16.9192 12.8002 12.8002 16.9192 12.8002 22.0002C12.8002 27.0812 16.9192 31.2002 22.0002 31.2002C27.0812 31.2002 31.2002 27.0812 31.2002 22.0002C31.2002 16.9192 27.0812 12.8002 22.0002 12.8002ZM11.2002 22.0002C11.2002 16.0355 16.0355 11.2002 22.0002 11.2002C27.9649 11.2002 32.8002 16.0355 32.8002 22.0002C32.8002 27.9649 27.9649 32.8002 22.0002 32.8002C16.0355 32.8002 11.2002 27.9649 11.2002 22.0002Z",
    fill: "#E50B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3646 14.3645C14.677 14.0521 15.1835 14.0521 15.4959 14.3645L29.6359 28.5045C29.9484 28.8169 29.9484 29.3235 29.6359 29.6359C29.3235 29.9483 28.817 29.9483 28.5046 29.6359L14.3646 15.4959C14.0521 15.1835 14.0521 14.6769 14.3646 14.3645Z",
    fill: "#E50B20"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#E50B20",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStockRed);
export default __webpack_public_path__ + "static/media/out-of-stock-red.929c925d0149d8b2364a84d4140c5213.svg";
export { ForwardRef as ReactComponent };